const errorsContainer = document.querySelector('.errors');

errorsContainer?.addEventListener('click', e => {
    const target = e.target.closest('.errors__close')

    if (!target) return

    target.closest('.errors__item')?.remove()
})

export function createError(text) {
    errorsContainer?.insertAdjacentHTML(
        "beforeend",
        `<div class="errors__item">
            <p class="errors__text">
                ${text}
            </p>
            <button class="errors__close" type="button"></button>
        </div>`
    );
}

export function removeError(selector) {
    const err = document.querySelectorAll(selector);
    for (const el of err) {
        el.remove();
    }
}
